module.exports = "assets/loading-2.gif?50c5e3";


//////////////////
// WEBPACK FOOTER
// ../node_modules/layui-layer/loading-2.gif
// module id = 23
// module chunks = 1